// Misure di tempo del tab Classifica (solo per capire dove si perde tempo; la riga con i numeri la vedono solo gli admin).
// perfMark('nome') registra l'istante; perfSpan('a','b') = millisecondi tra due marcatori.
const marks = {}
export const perfReset = () => { for (const k of Object.keys(marks)) delete marks[k] }
export const perfMark = (k) => { marks[k] = Date.now() }
export const perfSpan = (a, b) => (marks[a] != null && marks[b] != null ? marks[b] - marks[a] : null)
// segna solo la prima volta (dopo un perfClear): utile per "la lista e' comparsa" che puo' ripetersi
export const perfMarkOnce = (k) => { if (marks[k] == null) marks[k] = Date.now() }
// azzera i marcatori che iniziano con uno dei prefissi (a ogni nuova tappa)
export const perfClear = (prefixes) => { for (const k of Object.keys(marks)) if (prefixes.some(p => k.startsWith(p))) delete marks[k] }
